import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/notfound/notfound';
import { canActivateAuth } from '@/guards/auth.guard';
import { lookupGuard } from '@/config/lookup.config';
import { dashboardGuard, roleGuard } from '@/guards/role.guard';
import { Role } from '@/services/role.service';
import { AccessDenied } from '@/access-denied/access-denied';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [canActivateAuth, roleGuard(Role.Access), lookupGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./app/dashboard/dashboard').then((c) => c.Dashboard),
                canActivate: [dashboardGuard],
                data: { breadcrumb: 'Dashboard' }
            },
            {
                path: 'members',
                data: { breadcrumb: 'Mitglieder' },
                canActivate: [roleGuard(Role.BaseAccessMember)],
                loadChildren: () => import('@/members/members.routes')
            },

            {
                path: 'finance',
                data: { breadcrumb: 'Finanzen' },
                canActivate: [roleGuard(Role.BaseAccessFinance)],
                loadChildren: () => import('@/finance/finance.routes')
            },
            {
                path: 'modifications',
                data: { breadcrumb: 'Änderungsanträge' },
                canActivate: [roleGuard(Role.ProcessModification)],
                loadChildren: () => import('@/modifications/modifications.routes')
            },
            {
                path: 'jobs',
                data: { breadcrumb: 'Aufträge' },
                canActivate: [roleGuard(Role.BaseAccessJob)],
                loadChildren: () => import('@/jobs/jobs.routes')
            },
            // Export download routes – all handled by the same component.
            // Pattern 1: /exports/1463  (members, legacy email link)
            {
                path: 'exports/:id',
                loadComponent: () => import('./app/export-download/export-download').then((c) => c.ExportDownload),
                data: { exportType: 'members' }
            },
            // Pattern 2: /exports/grownup/1464  (in-app navigation after export POST)
            {
                path: 'exports/:type/:id',
                loadComponent: () => import('./app/export-download/export-download').then((c) => c.ExportDownload)
            },
            // Pattern 3: /member/divorce/1465  /member/grownup/1464  (typed email links)
            {
                path: 'member/:type/:id',
                loadComponent: () => import('./app/export-download/export-download').then((c) => c.ExportDownload)
            }
        ]
    },
    { path: 'access-denied', component: AccessDenied, canActivate: [canActivateAuth] },
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/notfound' }
];
